<template>
    <div
      class="scrollable earlyBird"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <v-header></v-header>
      <div class="content">
        <img src="../../assets/abb-pc.png" alt="">
        <div @click="goMsg" class="goMsg"></div>
      </div>
      
      <div class="btn" @click="btn">
            知道了
      </div>
      <v-footer></v-footer>
      <!-- <div class="loading">
        <el-dialog :visible.sync="reminder" :close-on-click-modal="false" style="height:600px;overflow-y: scroll;" >
            <div class="reportMsg">
                <p style="font-size:22px;margin-bottom: 10px;font: bold;text-align: center;margin-top: -30px;border-radius: 20px;">覆盖城市机构详情</p>
                <div v-for="item,index in early_bird_text.early_bird_text" class="city">
                  <p class="cityList">  {{item.city}}</p>
                    <p v-for="item1,index1 in item.hospital" class="hospitaList">
                        {{item1}}
                    </p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
    
              <el-button type="primary" @click="reminder=false">{{
                          $t("m.common.define")
                          }}</el-button>
            </span>
          </el-dialog>
      </div> -->


      <div id="interpret1">
        <el-dialog :visible.sync="reminder" :close-on-click-modal="false" style="border-radius: 20px;height:700px;">
            <p style="font-size:22px;margin-bottom: 10px;font: bold;text-align: center;margin-top: -30px;border-radius: 20px;">覆盖城市机构详情</p>
            <div v-for="item,index in early_bird_text.early_bird_text" class="city">
              <p class="cityList">  {{item.city}}</p>
                <p v-for="item1,index1 in item.hospital" class="hospitaList">
                    {{item1}}
                </p>
            </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="reminder=false">{{
                $t("m.common.closeBtn")
              }}</el-button>
          </span>
        </el-dialog>
      </div>
    </div> 
  </template>

<script>
    import axios from "axios";
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import header from "../common/header.vue";
    import footer from "../common/footer.vue";
    export default {
        name: "earlyBird",
        data() {
            return {
                reminder: false,
                early_bird_text: [],
            };
        },
        components: {
            "v-header": header,
            "v-footer": footer,
        },
        methods: {
            btn() {
                this.$router.push({
                    path: "/writeSubscribe",
                    query: {
                        type: "staff",
                        batch: this.$route.query.batch,
                    }
                })
            },
            goMsg() {
                this.reminder = true
            },
        },
        created() {
            this.fullscreenLoading = false;
            this.early_bird_text = JSON.parse(sessionStorage.getItem('staff_info'))
            console.log(this.early_bird_text)
        },

    };
</script>

<style scoped>
    .earlyBird {
        width: 100%;
        background: linear-gradient(180deg, #FFFCFC 0%, #FFE4E4 100%);
        padding-bottom: 100px;
    }
    
    .content {
        min-width: 1080px;
        width: 1080px;
        position: relative;
        height: 1500px;
        margin: 0 auto;
    }
    
    .content img {
        width: 100%;
        height: 100%;
    }
    
    .btn {
        width: 400px;
        height: 50px;
        background: #fff;
        color: #DC454E;
        margin: 0 auto;
        z-index: 99;
        border-radius: 25px;
        text-align: center;
        margin-top: -20px;
        cursor: pointer;
        font-weight: bold;
        font-size: 20px;
        line-height: 50px;
    }
    
    .goMsg {
        width: 100%;
        height: 50px;
        position: absolute;
        top: 60%;
        cursor: pointer;
        z-index: 999;
    }
    
    .city {
        text-align: center;
        line-height: 35px;
        margin: 20px 0;
        color: #fff;
    }
    
    .reportMsg {
        border-radius: 20px;
    }
    
    .cityList {
        width: 70px;
        margin: 0 auto;
        border-radius: 18px;
        height: 35px;
        background: linear-gradient(180deg, #FFAAB2 0%, #ED4D57 100%);
        margin-bottom: 20px;
    }
    
    .hospitaList {
        color: #333;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/earlyBird.vue